var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});

		$('.icon.svg').each(function() {
			let icon = $(this).data('icon');
			if (icon && icon.length) {
				let style = "url('/static/files/icons/" + icon + ".svg') no-repeat center / contain;";
				$(this).attr('style', "-webkit-mask: " + style + "mask: " + style);
			}
		});
	}
};

site.frontpage = {
	init: function() {
		site.owl.init('.news__carousel', {
			loop: false,
			dots: false,
			margin: 30,
			nav: true,
			navText: ["", ""],
			responsive: {
				0: {
					items: 1,
				},
				768: {
					items: 2,
				},
				992: {
					items: 3,
				},
				1440: {
					items: 4,
				}
			},
		});

		site.owl.init('.eventList__carousel', {
			loop: false,
			dots: false,
			margin: 30,
			nav: true,
			navText: ["", ""],
			responsive: {
				0: {
					items: 1,
				},
				768: {
					items: 2,
				},
				992: {
					items: 3,
				},
				1440: {
					items: 3,
				}
			},
		});

		site.owl.init('.social__carousel', {
			items: 1,
			loop: false,
			nav: true,
			slideBy: 1,
			dots: false,
			margin: 5,
			responsive: {
				1500: {
					items: 6,
				},
				1320 : {
					items: 4,
				},
				1080 : {
					items: 3,
				},
				880 : {
					items: 3,
				},
				576 : {
					items: 2,
				},
				0: {
					items: 1,
				}
			},
			navText: ["", ""],
		});

		site.owl.init('.front__carousel', {
			loop: false,
			dots: false,
			margin: 30,
			nav: true,
			navText: ["", ""],
			responsive: {
				0: {
					items: 1,
				},
				768: {
					items: 2,
				},
				992: {
					items: 3,
				},
				1440: {
					items: 4,
				}
			},
		});
	}
};

site.content__view = {
	init: function () {
		site.owl.init('.content__info .images', {
			loop: false,
			dots: false,
			margin: 0,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			nav: true,
			items: 1,
			navText: ["", ""],
		});

		site.owl.init('.main__content .images.carousel', {
			loop: false,
			dots: false,
			margin: 30,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			nav: true,
			items: 1,
			navText: ["", ""],
			responsive: {
				0: {
					items: 1,
				},
				768: {
					items: 1,
				},
				992: {
					items: 2,
				},
				1024: {
					items: 2,
				}
			},
		});
	}
};

site.readspeker = {
	init: function() {
		window.rsConf = {
			general: {usePost: true}
		};
		site.readspeker.accordionFix();
	},
	accordionFix: function() {
		var $accordions = $('.accordion');
		if (!$accordions.length) {
			return;
		}
		$accordions.removeClass('rs_preserve');

		document.addEventListener('DOMContentLoaded', ReadSpeaker.q(function() {
			var $current;
			rspkr.c.addEvent('onBeforeSync', function(type, id) {
				var element = $rs.get('#sync' + id),
					$parent = $(element.parentElement);

				if (!$current || $current[0] !== $parent[0]) {
					var $closedAccordion = $parent.parents('.accordion:not(.open)');
					if ($closedAccordion.length) {
						$closedAccordion.addClass('open');
					}
					$current = $parent;
				}
			});
		}), false);
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.readspeker.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	if ($body.is('.content__view')) {
		site.content__view.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	$('.shareThis').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
